<template>
  <div class="map">
    <MglMap
      :mapStyle="mapStijl"
      sourceId="cartiqo"
      layerId="background"
      :interactive="interactive"
      :attributionControl="false"
      :hash="interactive"
      @load="onMapLoad"
      @move="onMapMove"
      @click="onMapClick"
      @mousemove="onMapMoveMouse"
      :zoom.sync="zoom"
      :center.sync="center"
      :bearing.sync="bearing"
    >
      <MglPopup
        v-if="showPopup"
        :showed="showPopup"
        :interactive="interactive"
        :closeButton="false"
        :closeOnClick="false"
        :coordinates="coordinatesArray"
      >
        <div class="popup-content">
          <div id="titelpopdown">| {{titel}}</div>
          <div id="datum">{{lijn1}}</div>
          <div>{{lijn2}}</div>
          <div>{{lijn3}}</div>
          <div>{{lijn4}}</div>
        </div>
      </MglPopup>
      <div  v-if="interactive">
      <MglMarker

        :key="marker.properties.fid"
        v-for="marker in geojson"
        :coordinates="marker.geometry.coordinates"
      >
        <img
          id="verhaal"
          @click="terugVerhaal(marker.properties.naam)"
          slot="marker"
          v-bind:src="'/img/verhaal_'+marker.properties.naam+'.png'"
          v-bind:title=" 'Ga terug naar het verhaal van '+ marker.properties.naam "
        />
      </MglMarker>
      </div>
    </MglMap>
  </div>
</template>
<style>
.map {
  height: 100%;
}

.popup-content {
  font-size: 10pt;
}
#titelpopdown {
  font-size: 11pt;
  font-weight: bold;
  margin-top: 10px;
}

#popdown {
  display: none;
}
#verhaal {
  cursor: pointer;
}
</style>
<script>
import { MglMap, MglPopup, MglMarker } from "vue-mapbox";

import { mapGetters } from "vuex";

const shadowLayers = ["Frontline-shadow", "Bom-shadow"];
const dayLayers = [
  "Vakgrens",
  "Hoofdkwartier",
  "Bombardement",
  "Eenheden",
  "bevrijdeplaatsen",
  "Vestingen",
  "Frontline",
  "Frontline-tekst",
  "Vliegvelden",
  "Bom-shadow",
  "Luchtlanding",
  "IreneBrigade",
  "duits_vliegvelden",
  "stoottroepen_disloc",
  "stoottroepen_opr",
  "gezagstroepen",
  "kl_oprichting",
  "bezetgebied",
  "inundatiezones",
  "landingszones",
  "voedseldroppings",
  "monumenten",
  "graven"
];
const chapterLayers = [
  "bezetgebied",
  "bezetgebied_maand",
  "Vestingen",
  "atlanticwall001",
  "annotatie_punten_cirkel",
  "annotatie_punten_tekst",
  "annotatie_lijnen",
  "vliegtuigen_op_lijn",
  "annotatie_vlakken",
  "atlanticwall002",
  "IreneBrigade",
  "Luchtlanding"
];

const clickableLayers = [
  "Eenheden",
  "IreneBrigade",
  "Bombardement",
  "Vestingen",
  "Vliegvelden",
  "Frontline",
  "Hoofdkwartier",
  "Luchtlanding",
  "landingszones",
  "duits_vliegvelden",
  "stoottroepen_disloc",
  "stoottroepen_opr",
  "gezagstroepen",
  "kl_oprichting",
  "voedseldroppings", 
  "graven",
  "monumenten"
];
function getBounds(event, store) {
  const canvas = event.map.getCanvas();
  const w = canvas.width;
  const h = canvas.height;
  const cUL = event.map.unproject([0, 0]).toArray();
  const cUR = event.map.unproject([w, 0]).toArray();
  const cLR = event.map.unproject([w, h]).toArray();
  const cLL = event.map.unproject([0, h]).toArray();
  const coordinates = [cUL, cUR, cLR, cLL, cUL];
  store.commit("map/setBounds", coordinates);
}
function activateChapterLayers(id, month, map) {
  if (id.indexOf("hfst") >= 0) {
    let hfdtk = parseInt(id.substr(-1), 10);
    for (let layer of chapterLayers) {
      if (layer === "Vestingen") {
        map.setFilter(layer, [">=", ["get", "begincounter"], 0]);
      } else if (layer === "bezetgebied_maand") {
        map.setFilter(layer, [">", ["get", "maand"], month]);
      } else {
        map.setFilter(layer, [
          "all",
          [
            "<=",
            ["to-number", ["coalesce", ["get", "beginhoofdstuk"], 0]],
            hfdtk
          ],
          [
            ">=",
            ["to-number", ["coalesce", ["get", "eindhoofdstuk"], 99]],
            hfdtk
          ],
          ["==", ["get", "maand"], month]
        ]);
      }
    }
  }
}
// function activateMonthFilter(month, map) {
//   for (let layer of dayLayers) {
//     map.setFilter(layer, ["==", ["get", "maand"], month]);
//   }
// }
function activateDayFilter(counter, map) {
  for (let layer of dayLayers) {
    if (layer === "bezetgebied") {
      map.setFilter(layer, [
        "all",
        ["<=", "begincounter", counter],
        [">", "eindcounter", counter],
        [">=", "maand", 4]
      ]);
    } else {
      map.setFilter(layer, [
        "all",
        ["<=", "begincounter", counter],
        [">=", "eindcounter", counter]
      ]);
    }
  }
}
function activateShadowFilter(counter, map) {
  for (let layer of shadowLayers) {
    if (counter > 5) {
      map.setFilter(layer, [
        "all",
        ["<=", "begincounter", counter - 1],
        [">=", "begincounter", counter - 6]
      ]);
    } else {
      map.setFilter(layer, ["all", ["<=", "begincounter", counter]]);
    }
  }
}

function fillPopup(layer) {
  let popupcontent = {};
  switch (layer.layer.id) {
    case "atlanticwall001":
      popupcontent.titel = "Atlantic Wall";
      popupcontent.lijn1 = layer.properties.begindatum;
      break;
    case "Eenheden":
      popupcontent.titel = "Geallieerde eenheid";
      popupcontent.lijn1 = layer.properties.begindatum;
      popupcontent.lijn2 =
        layer.properties.naam + " " + layer.properties.categorie;
      popupcontent.lijn3 = layer.properties.nationaliteit;
      break;
    case "Bombardement":
      popupcontent.titel = "Bombardement 320 Squadron";
      popupcontent.lijn1 = layer.properties.begindatum;
      popupcontent.lijn2 =
        "Doelwit: " +
        layer.properties.categorie +
        ", " +
        layer.properties.plaats;
      break;
    case "Vestingen":
      popupcontent.titel = "Atlantikwall (Festung)";
      popupcontent.lijn1 = layer.properties.naam;
      popupcontent.lijn2 = layer.properties.naam2;
      break;
    case "Vliegvelden":
      popupcontent.titel = "Geallieerd vliegveld";
      popupcontent.lijn1 = layer.properties.naam;
      popupcontent.lijn2 = "Operationeel van " + layer.properties.begindatum;
      popupcontent.lijn3 = "tot " + layer.properties.einddatum;
      break;
    case "Frontline":
      popupcontent.titel = "Frontlijn";
      popupcontent.lijn1 = layer.properties.begindatum;
      break;
    case "Hoofdkwartier":
      popupcontent.titel = "Tactisch hoofdkwartier";
      popupcontent.lijn1 =
        layer.properties.naam + ", " + layer.properties.categorie;
      popupcontent.lijn2 = "Van " + layer.properties.begindatum;
      popupcontent.lijn3 = "tot " + layer.properties.einddatum;
      break;
    case "Luchtlanding":
      popupcontent.titel = "Luchtlanding";
      popupcontent.lijn1 = layer.properties.naam;
      popupcontent.lijn2 = layer.properties.categorie;
      popupcontent.lijn3 = layer.properties.begindatum;
      break;
    case "IreneBrigade":
      popupcontent.titel = "Nederlandse eenheid";
      popupcontent.lijn1 = layer.properties.naam + " (commandopost)";
      popupcontent.lijn2 = "Van " + layer.properties.begindatum;
      popupcontent.lijn3 = "tot " + layer.properties.einddatum;
      break;
    case "landingszones":
      popupcontent.titel = "Landings Zone";
      popupcontent.lijn1 = layer.properties.naam;
      break;
    case "duits_vliegvelden":
      popupcontent.titel = "Duits Vliegveld";
      popupcontent.lijn1 = layer.properties.naam;
      popupcontent.lijn2 = "Van " + layer.properties.begindatum;
      popupcontent.lijn3 = "tot " + layer.properties.einddatum;
      break;
    case "stoottroepen_disloc":
      popupcontent.titel = "Stoottroepen";
      popupcontent.lijn1 = layer.properties.naam;
      popupcontent.lijn2 = "Van " + layer.properties.begindatum;
      popupcontent.lijn3 = "tot " + layer.properties.einddatum;
      popupcontent.lijn4 = "Onder bevel van " + layer.properties.categorie;
      break;
    case "stoottroepen_opr":
      popupcontent.titel = "Stoottroepen";
      popupcontent.lijn1 = layer.properties.begindatum;
      popupcontent.lijn2 = "Oprichting van " + layer.properties.naam;
      popupcontent.lijn3 = "Onder bevel van " + layer.properties.categorie;
      break;
    case "gezagstroepen":
      popupcontent.titel = "Korps Gezagstroepen";
      popupcontent.lijn1 = layer.properties.begindatum;
      popupcontent.lijn2 = "Oprichting van " + layer.properties.naam;
      popupcontent.lijn3 = layer.properties.categorie;
      break;
    case "kl_oprichting":
      popupcontent.titel = "Koninklijke Landmacht";
      popupcontent.lijn1 = layer.properties.begindatum;
      popupcontent.lijn2 = "Oprichting van " + layer.properties.naam;
      break;
    case "voedseldroppings":
      popupcontent.titel = "Voedseldropping";
      popupcontent.lijn1 = layer.properties.begindatum;
      popupcontent.lijn2 = layer.properties.categorie;
      popupcontent.lijn3 = layer.properties.eenheid;
      popupcontent.lijn4 = "Gewicht: " + layer.properties.tonnage;
      break;
    case "graven":
      popupcontent.titel = "Oorlogsbegraafplaats";
      popupcontent.lijn1 = layer.properties.naam;
      popupcontent.lijn2 = layer.properties.plaats;
      popupcontent.lijn3 = layer.properties.aantal + " graven";
      break;
    case "monumenten":
      popupcontent.titel = "Oorlogsmonument";
      popupcontent.lijn1 = layer.properties.naam;
      popupcontent.lijn2 = (layer.properties.address === undefined) ? '' : layer.properties.address  + " " + layer.properties.plaats;
      popupcontent.lijn3 = (layer.properties.unveilingyear === undefined) ?  '' : "Onthuld: " + layer.properties.unveilingyear;
      break;
    default:
      popupcontent.titel = "Geen data";
      break;
  }
  return popupcontent;
}

export default {
  props: ["interactive"],
  components: {
    MglMap,
    MglPopup,
    MglMarker
  },
  data() {
    return {
      updateStyle: false,
      hash: false,
      coordinates: [0, 0],
      titel: "",
      lijn1: "",
      lijn2: "",
      lijn3: "",
      lijn4: "",
      showPopup: true,
      geojson: {}
    };
  },
  methods: {
    async onMapLoad(event) {
      this.map = event.map;
      // this.map.showCollisionBoxes = true;
      getBounds(event, this.$store);
      if (this.interactive) {
        this.map.setMaxBounds(this.$store.state.config.maxbounds);
        this.map.setMaxZoom(this.$store.state.config.maxZoom);
        activateDayFilter(this.$store.state.map.counterDay, event.map);
        activateShadowFilter(this.$store.state.map.counterDay, event.map);
      } else {
        activateChapterLayers(
          this.$store.state.story.id,
          this.$store.state.config.verhaalMaand,
          this.map
        );
        this.map.flyTo(this.$store.getters["story/getCamera"]);
      }
    },
    onMapMove(event) {
      getBounds(event, this.$store);
    },
    disableUpdateStyle() {
      this.updateStyle = false;
    },
    onMapClick(event) {
      let e = event.mapboxEvent;
      this.coordinates = [e.lngLat.lng, e.lngLat.lat];
      var bbox = [
        [e.point.x - 5, e.point.y - 5],
        [e.point.x + 5, e.point.y + 5]
      ];
      let layercontent = event.map.queryRenderedFeatures(bbox, {
        layers: clickableLayers
      });

      if (layercontent && layercontent[0] && layercontent[0].layer) {
        this.showPopup = true;
        let popupcontent = fillPopup(layercontent[0]);
        this.titel = popupcontent.titel;
        this.lijn1 = popupcontent.lijn1;
        this.lijn2 = popupcontent.lijn2;
        this.lijn3 = popupcontent.lijn3;
        this.lijn4 = popupcontent.lijn4;
      } else {
        this.showPopup = false;
        this.titel = "";
        this.naam = "";
        this.datum = "";
      }
    },
    onMapMoveMouse(event) {
      let e = event.mapboxEvent;
      var bbox = [
        [e.point.x - 5, e.point.y - 5],
        [e.point.x + 5, e.point.y + 5]
      ];
      if (event.map.isStyleLoaded()) {
        let features = event.map.queryRenderedFeatures(bbox, {
          layers: clickableLayers
        });
        event.map.getCanvas().style.cursor = features.length ? "pointer" : "";
      }
    },
    terugVerhaal(gekozenMaand) {
      this.$router.push({
        name: "verhaal",
        params: {
          month: gekozenMaand
        }
      });
    }
  },
  computed: {
    ...mapGetters("story", ["getCamera", "getId"]),
    ...mapGetters("map", ["getCounterDay", "getMapStyle"]),
    zoom: {
      get: function() {
        return this.$store.state.map.zoom;
      },
      set: function(value) {
        this.$store.commit("map/setZoom", value);
      }
    },
    center: {
      get: function() {
        return this.$store.state.map.center;
      },
      set: function(value) {
        if(value.lng == this.center.lng) return false
        this.$store.commit("map/setCenter", value);
      }
    },
    bearing: {
      get: function() {
        return this.$store.state.map.north;
      },
      set: function(value) {
        this.$store.commit("map/setNorth", value);
      }
    },
    mapStijl() {
      let m = this.$route.params.month;
      if (this.interactive) {
        if (!this.updateStyle) {
          if (this.map && this.$store.state.config)
            this.map.setMaxBounds(this.$store.state.config.maxbounds);
          if (
            m === "juni" ||
            m === "juli" ||
            m === "augustus" ||
            m === "september"
          ) {
            return this.$store.getters["map/getMapStyle"];
          } else {
            return "/nimh_top100_v2.json";
          }
        } else {
          this.disableUpdateStyle()
          return this.$store.getters["map/getMapStyle"];
        }
      } else {
        return this.$store.getters["config/getMapStyle"];
      }
    },
    coordinatesArray() {
      return [this.coordinates[0], this.coordinates[1]];
    }
  },
  mounted() {},
  created() {
    // We need to set mapbox-gl library here in order to use it in template
    this.map = null;
    let self = this;
    fetch("/verhaal_start_posities.geojson")
      .then(resp => resp.json())
      .then(function(jsondata) {
        self.geojson = jsondata.features;
      });
  },
  watch: {
    getCamera(c) {
      if (c && c.center && this.map) this.map.flyTo(c);
    },
    getId(id) {
      if (!this.map) return false;
      if (!this.interactive) {
        activateChapterLayers(
          id,
          this.$store.state.config.verhaalMaand,
          this.map
        );
      }
    },
    getCounterDay(count) {
      if (this.interactive) {
        activateDayFilter(count, this.map);
        activateShadowFilter(count, this.map);
      }
    },
    getMapStyle() {
      if (this.interactive) {
        this.updateStyle = true;
        let counter = this.$store.state.map.counterDay;
        let list = function(e) {
          activateDayFilter(counter, e.target);
          activateShadowFilter(counter, e.target);
          e.target.off("styledata", list);
        };
        this.map.on("styledata", list);
      }
    }
  }
};
</script>
